import { useState, useRef } from 'react';
import WizardStep from 'components/Wizard/WizardStep';
import WizardProgress from 'components/Wizard/WizardProgress';
import Button from 'react-bootstrap/Button';
import { CSSTransition } from 'react-transition-group';
import './Wizard.css'

export const Direction =
{
    Forward: 'Forward',
    Reverse: 'Reverse'
}

export const StepType =
{
    PartialStep: 'PartialStep',
    Step: 'Step'
}

// Note: Unable to effectively mock CSSTransition to test events.  
// Therefore disableAnimation prop is for unit testing purposes only.
export default function Wizard({ steps, handleFinish, finishText, disableAnimation = false, disableFinish = false }) {

    const nodeRef = useRef(null);

    const exitClassForward = "animate__animated animate__slideInRight";
    const enterClassForward = "animate__animated animate__slideOutLeft";

    const exitClassReverse = "animate__animated animate__slideInLeft";
    const enterClassReverse = "animate__animated animate__slideOutRight";

    const totalSteps = steps?.length ?? 0;
    const [stepState, setStepState] = useState({ currentStep: 0, nextStep: null, completedSteps: [], direction: Direction.Forward, transition: false });

    const handelGotoStep = (event, index) => {
        event.preventDefault();

        if (index > stepState.currentStep) {
            setStepState({ ...stepState, nextStep: index, direction: Direction.Forward, transition: true });
        } else if (index < stepState.currentStep) {
            setStepState({ ...stepState, nextStep: index, direction: Direction.Reverse, transition: true });
        } else {
            return false;
        }

        return false;
    }

    const beginNextStep = () => {
        if (steps[stepState.currentStep].onNextStep) {
            steps[stepState.currentStep].onNextStep.call(this, function (continueNextStep) { if (continueNextStep) handleNextStep(); });
        } else {
            handleNextStep();
        }
    }

    const handleNextStep = () => {

        const newStepState = { ...stepState, nextStep: stepState.currentStep + 1, direction: Direction.Forward, transition: true };

        if (newStepState.completedSteps.indexOf(stepState.currentStep) === -1)
            newStepState.completedSteps.push(stepState.currentStep);
        
        setStepState(newStepState);

    }

    const handlePreviousStep = () => {

        const newStepState = { ...stepState, nextStep: stepState.currentStep - 1, direction: Direction.Reverse, transition: true };

        setStepState(newStepState);
    }

    const completeStepTransition = () => {

        if (stepState.nextStep !== null) {
            setStepState({ ...stepState, currentStep: stepState.nextStep, nextStep: null, transition: false });
            
        }
    }

    if (totalSteps === 0)
        return (<></>);

    if (disableAnimation && stepState.nextStep !== null)
        completeStepTransition();

    return (
        <div style={{ overflow: "hidden" }} aria-busy={ stepState.transition }>
            <WizardProgress steps={steps} currentStep={stepState.currentStep} completedSteps={stepState.completedSteps} changeStep={handelGotoStep} />
            <hr className="my-5" />
            <CSSTransition
                in={stepState.transition}
                nodeRef={nodeRef}
                timeout={700}
                classNames={{
                    enter: (stepState.direction === Direction.Forward) ? enterClassForward : enterClassReverse,
                    enterActive: (stepState.direction === Direction.Forward) ? enterClassForward : enterClassReverse,
                    enterDone: 'hideSteps',
                    exit: (stepState.direction === Direction.Forward) ? exitClassForward : exitClassReverse,
                    exitActive: (stepState.direction === Direction.Forward) ? exitClassForward : exitClassReverse,
                    exitDone: (stepState.direction === Direction.Forward) ? exitClassForward : exitClassReverse
                }}
                onEntered={() => completeStepTransition()} >
                <div ref={nodeRef}>
                    {steps.map((step, index) => { return <WizardStep key={index} currentStep={stepState.currentStep} stepIndex={index} >{ step.content }</WizardStep> })}

                    <hr className="my-5" />

                    <div className="d-flex justify-content-end">
                        <Button size="lg" style={{ display: (stepState.currentStep === 0) ? "none" : "inherit" }} variant="secondary" className="ppm-button-secondary me-sm-0 me-md-3" onClick={handlePreviousStep} type="button">Back</Button>
                        <Button size="lg" style={{ display: (stepState.currentStep === (totalSteps - 1)) ? "none" : "inherit" }} variant="primary" className="ppm-button-primary ms-1 ms-md-3" onClick={beginNextStep} type="button">Continue</Button>
                        <Button size="lg" style={{ display: (stepState.currentStep === (totalSteps - 1)) ? "inherit" : "none" }} variant="primary" className="ppm-button-primary ms-1 ms-md-3" disabled={disableFinish} onClick={handleFinish} type={(handleFinish) ? "button" : "submit"}>
                            {finishText ?? "Finish"}
                        </Button>
                    </div>

                    <hr className="my-5" />

                </div>
            </CSSTransition>
        </div>
    );
}